
<script>
export default {
  name: 'payment-method-select',
  computed: {
    methodSelectForm() {
      return this.$store.getters['payment/methodSelectForm']
    },
    invoiceForm() {
      return this.$store.getters['payment/invoiceForm']
    },
    paymentHash() {
      return this.$store.getters['payment/billingData'].paymentHash
    }
  },
  methods: {
    loadGuide(supplierCode) {
      const {
        orderId,
        sum
      } = this.methodSelectForm

      this.$store.commit('payment/setInvoiceForm', {
        isLoading: true,
        supplierCode
      })

      this.$store.dispatch('payment/getInvoice', {
        supplierCode,
        orderId,
        sum
      })
    },
    closeModal() {
      this.$store.commit('payment/setMethodSelectForm', {
        isActive: false
      })
    }
  }
}
</script>
<template>
  <b-modal
    :active="methodSelectForm.isActive"
    scroll="keep"
    :can-cancel="['outside', 'esc']"
    :width="1200"
    @close="closeModal"
  >
    <div class="card">
      <div class="modal__wrap card-content">
        <div class="modal__content">
          <div class="payment-method-select">
            <h2 class="payment-method-select__header">
              Выберите способ оплаты:
            </h2>
            <div
              v-if="methodSelectForm.isLoading"
              class="order-payment__loading"
            >
              <b-loading
                :is-full-page="false"
                :active="methodSelectForm.isLoading"
              />
            </div>
            <div v-else>
              <h3 class="payment-method-select__subheader">
                Оплата по счёту или переводом
              </h3>
              <p
                v-if="methodSelectForm.hasError"
                class="payment-method-select__description payment-method-select__description--error"
              >
                Не удалось загрузить список платежных сервисов, попробуйте позднее.
              </p>
              <div
                v-else
              >
                <p class="payment-method-select__description">
                  После выбора платежного оператора Вы сможете скачать инструкцию по оплате заказа.
                </p>
                <div class="payment-method-select__variants">
                  <div
                    v-for="(supplier, index) in methodSelectForm.paymentSuppliers"
                    :key="index"
                    class="payment-method-select__variants-item"
                    :class="{
                      'payment-method-select__variants-item--disabled': invoiceForm.isLoading
                    }"
                    @click="loadGuide(supplier.code)"
                  >
                    <b-loading
                      :is-full-page="false"
                      :active="invoiceForm.supplierCode === supplier.code"
                    />
                    <div class="payment-method-select__variants-item-logo">
                      <img
                        :src="supplier.logo"
                      >
                    </div>
                    <div class="payment-method-select__variants-item-caption">
                      <div>
                        <p class="payment-method-select__variants-item-name">
                          {{ supplier.name }}
                        </p>
                        <p class="payment-method-select__variants-item-commission">
                          {{
                            supplier.commission
                              ? `Комиссия ${supplier.commission}%`
                              : 'Без комиссии'
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h3 class="payment-method-select__subheader">
                Оплата по карте
              </h3>
              <p class="payment-method-select__description">
                Вы будете перенаправлены на страницу оплаты.
              </p>
              <div class="payment-method-select__variants">
                <router-link
                  class="payment-method-select__variants-item"
                  :class="{
                    'payment-method-select__variants-item--disabled': invoiceForm.isLoading
                  }"
                  :to="{
                    name: 'Payment',
                    params:{
                      paymentHash: paymentHash
                    }
                  }"
                  target="_blank"
                >
                  <div class="payment-method-select__variants-item-logo">
                    <img src="@/assets/images/card-payment.png">
                  </div>
                  <div class="payment-method-select__variants-item-caption">
                    <div>
                      <p class="payment-method-select__variants-item-name">
                        Visa, Mastercard, МИР
                      </p>
                      <p class="payment-method-select__variants-item-commission">
                        Комиссия {{ methodSelectForm.cardCommission }}%
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>